import { api } from "./api";

const BASE_URL = "/usage-analytics";

export default class usageAnalyticsService {
  static startSession = async () => {
    const { data } = await api.post(`${BASE_URL}/sessions`);
    return data;
  };

  static heartbeat = async (sessionId) => {
    const { data } = await api.patch(
      `${BASE_URL}/sessions/${sessionId}/heartbeat`,
    );
    return data;
  };

  static closeSession = async (sessionId) => {
    const { data } = await api.patch(
      `${BASE_URL}/sessions/${sessionId}/close`,
    );
    return data;
  };

  static recordEvents = async (events) => {
    const { data } = await api.post(`${BASE_URL}/events`, { events });
    return data;
  };

  static getOverview = async (params) => {
    const { data } = await api.get(`${BASE_URL}/overview`, { params });
    return data;
  };
}
